<div class="marketplace">
  <mat-accordion [displayMode]="'flat'" [multi]="true">
    <mat-expansion-panel hideToggle  #panel>
      <mat-expansion-panel-header>
        <div class="w-100">
          <div class="marketplace_header">
            <div class="marketplace_icon">
              <app-channal-icon [channal]="marketplace"></app-channal-icon>
            </div>
            <div class="marketplace_name">{{ accountRegionId ? 'Amazon' : marketplace }} <span *ngIf="accountRegionId == AccountRegion.AmazonUk || accountRegionId == AccountRegion.AmazonAU" class="marketplace_name--region">{{accountRegionId == AccountRegion.AmazonUk ? 'Europe' : 'Far East'}}</span></div>
            <span class="marketplace_alert m-auto" *ngIf="needUpdate"><i class="fal fa-exclamation-triangle me-2"></i>Expand to Update your Amazon Connections</span>
            <div class="marketplace_action">
              <app-button *ngIf="!selectedPortal" (click)="openAddConnection($event, marketplace)" [buttonSize]="'action'" [isDisabled]="!isProductSelected">Add</app-button>
              <app-button *ngIf="selectedPortal" (click)="openAddConnection($event)" [buttonSize]="'action'" [isDisabled]="!isProductSelected">Close</app-button>
            </div>
            <div matTooltip="Connected accounts" class="marketplace_count">
              {{connectedAccounts.length}}
            </div>
            <div  class="marketplace_expand">
              <i class="fal " [ngClass]="{'fa-chevron-down': panel.expanded, 'fa-chevron-right': !panel.expanded}"></i>
            </div>
          </div>
  
          <div class="marketplace_new-portal" (click)="cancelEvent($event)" [hidden]="!selectedPortal">
            <ng-template [cdkPortalOutlet]="selectedPortal" (attached)="attach($event)"></ng-template>
          </div>
        </div>
      </mat-expansion-panel-header>

      <div class="marketplace_body" *ngIf="marketplace.length">
  
        <div class="connection">
          <div class="connection_item" [ngClass]="{'connection_other-item': accountRegionId !== AccountRegion.Amazon}" *ngFor="let account of connectedAccounts">
            <div class="connection_name" [ngClass]="{'connection_name--inactive': !account.isActive}">
              {{ account.name }} <span *ngIf="!account.isActive" class="connection_inactive">(Inactive)</span>
            </div>
            <div class="connection_authentication" *ngIf="(accountRegionId === AccountRegion.Amazon && user.isNetYard || isPlanyard == 1) && account.type.includes('Amazon')">
              <div [matTooltip]="account.isActive ? 'Amazon authentication is completed' : 'Amazon authentication is not completed'"
               class="connection_authentication--action" [ngClass]="{'not-completed': !account.isActive}"><span >Amazon</span>
              </div>
              <div class="connection_authentication--action" [ngClass]="{'not-completed': !account.ppcToken}">
                <span  class="me-2" [matTooltip]="account.ppcToken ? 'Advertising authentication is completed' : 'Advertising authentication is not completed'"> Advertising </span>  
                <app-button (click)="reconnectPpc(account)" [buttonSize]="'action'" *ngIf="!account.ppcToken && account.isActive" >Connect</app-button>
              </div>
            </div>
            <div class="connection_action">
              <app-button class="reconnect-btn" [buttonSize]="'small'" (click)="reconnect(account)" [buttonColor]="'accent'"
              [buttonStyle]="'wire'" *ngIf="(account.reftoken === 0 && (accountRegionId === AccountRegion.Amazon || accountRegionId == AccountRegion.AmazonUk || accountRegionId == AccountRegion.AmazonAU)) || (account.rtoken === 0 && marketplace == 'eBay')">Reconnect</app-button>
              <app-button [buttonSize]="'small'" [buttonStyle]="'underline'" (click)="getDetail(account)">Details</app-button>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
